<ng-container>
  <div class="h-[165px]">
    <cft-map-address
      class="h-[150px]"
      [address]="mapLocation.location.address"
      [gMapsApiKey]="googleMapsApiKey"
      [defaultLocationLabel]="mapLocation.location.default ? defaultLocationLabel : undefined"
      [zoom]="zoom"
      rounded="top"
    ></cft-map-address>
    @if (location.representativePerson) {
      <div
        (click)="avatarClick.emit(); $event.preventDefault(); $event.stopPropagation()"
        class="absolute mt-[-15px] ml-md flex h-[30px] w-[30px] items-center justify-center rounded-full border border-purple-300 bg-purple-500 text-2xs font-bold text-white"
      >
        {{ location.representativePerson | bgoInitials }}
      </div>
    }
  </div>
  <div class="p-md">
    <div class="space-y-sm rounded-3 bg-grey-50 px-md py-sm">
      <span class="heading-sm">
        {{ contactDetailsHeading }}
      </span>
      <address class="min-h-20 text-sm not-italic">
        <ul class="space-y-xs">
          <li class="flex space-x-xs">
            <fa-icon [icon]="locationIcon"></fa-icon>
            <span
              class="overflow-hidden text-ellipsis whitespace-nowrap"
              [title]="location.address | bgoFullLocation: true"
            >
              {{ location.address | bgoFullLocation: true }}
            </span>
          </li>
          @if (location.email) {
            <li class="flex space-x-xs">
              <fa-icon [icon]="emailIcon"></fa-icon>
              <span class="overflow-hidden text-ellipsis whitespace-nowrap" [title]="location.email">
                {{ location.email }}
              </span>
            </li>
          }
          @if (location.phoneNumber) {
            <li class="flex space-x-xs">
              <fa-icon [icon]="phoneIcon"></fa-icon>
              <span class="overflow-hidden text-ellipsis whitespace-nowrap" [title]="location.phoneNumber">
                {{ location.phoneNumber }}
              </span>
            </li>
          }
        </ul>
      </address>
    </div>
  </div>
  <div [ngClass]="{'border-t border-grey-300 px-md py-sm': actions.children.length}">
    <div #actions>
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
